import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types';
import { answerRequest as answerRequestRemote, fetchInvestigations as fetchInvestigationsRemote} from '../../../../services';
import CardInvestigation from './card_investigation'
import { Link } from 'react-router-dom';
import { Translate, withLocalize } from 'react-localize-redux';
import Loader from '../../../Loader';
import { decryptData, encryptData } from '../../../../utils/index.jsx';
import { useHistory } from "react-router-dom";
import { Alert } from "@mui/lab";
import { Grid, Typography } from '@mui/material';
import { ButtonAdd } from "../../../general/mini_components";

function AllInvestigations(props){
    const [investigations, setInvestigations] = useState(props.initialState && props.initialState.investigations ? props.initialState.investigations : null); 
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [answer, setAnswer] = useState(null);
    const [needsInvitationLink, setNeedsInvitationLink] = useState(false);
    const history  = useHistory();

    async function answerRequest(index, value){
        try{
            setIsLoading(true);
            //Desencriptamos la clave de la investigacion
            const investigation = investigations[index];
            // SHER-803: a token-wrapped invitation opens only with the secret in the invite link,
            // which this list does not have. Accepting happens on the link's page; declining needs
            // no key at all.
            if(investigation.encryptedKeyUsed === 2){
                if(value === 2){
                    setNeedsInvitationLink(true);
                    setIsLoading(false);
                    return;
                }
                const declined = await answerRequestRemote(investigation.uuid, value, undefined);
                if(declined.status === 200){
                    setAnswer(true);
                }
                else{
                    setError(true);
                }
                setIsLoading(false);
                return;
            }
            const keyRawInvestigation = decryptData(investigation.keyResearcherInvestigation , import.meta.env.VITE_APP_DEFAULT_RESEARCH_PASSWORD);
            // SHER-697: unless the pending key IS an empty wrap (<=44 chars). Then the
            // investigation itself is permanently on the empty key — its data is already
            // encrypted under "" — and refusing here would strand every invitee the
            // SHER-697 share carve-out lets through. Without this the invitation can be
            // sent but never accepted, which is worse than blocking it outright.
            const pendingKey = investigation.keyResearcherInvestigation;
            const investigationOnEmptyKey = typeof pendingKey === "string"
                && pendingKey.length > 0 && pendingKey.length <= 44;
            // SHER-344: if the pending investigation key didn't decrypt (empty), accepting would
            // re-wrap encrypt("") and store an unusable key — abort and surface an error instead.
            if(!keyRawInvestigation && !investigationOnEmptyKey){
                setError(true);
                setIsLoading(false);
                return;
            }
            const keyInvestigationResearcher = encryptData(keyRawInvestigation, localStorage.getItem("rawKeyResearcher"));
            // SHER-344: verify the re-wrap round-trips before sending (previously this check was
            // computed but only logged, so an empty/garbage key slipped through silently).
            const testkeyRawInvestigation = decryptData(keyInvestigationResearcher, localStorage.getItem("rawKeyResearcher"));
            if(testkeyRawInvestigation !== keyRawInvestigation){
                setError(true);
                setIsLoading(false);
                return;
            }

            const response = await answerRequestRemote(investigations[index].uuid, value, keyInvestigationResearcher);
            if(response.status === 200){
                
                if(value === 2){
                    if (import.meta.env.VITE_APP_PRODUCT === "HOSPITAL") {
                        window.location.reload();
                    }
                    else{
                        history.push("/investigation/show/"+investigations[index].uuid);
                    }
                    
                }
                setAnswer(true);
            }
            else{
                setError(true);
            }
            setIsLoading(false);
        }
        catch(error){
            console.log(error);
            setError(true);
            setIsLoading(false);
        }
    }
    useEffect(() => {
        async function fetchInvestigations(){
            try{
                setIsLoading(true);
                
                const response = await fetchInvestigationsRemote();
                if(response.status === 200){
                    setInvestigations(response.investigations);
                }
                else{
                    setError(true);
                }
                setIsLoading(false);
            }
            catch(error){
                setError(true);
                setIsLoading(false);
            }
        }
        if(!investigations || answer){
            fetchInvestigations();
        }
        else{
            setIsLoading(false);
        }
    }, [answer])
    
    if(isLoading){
        return(
            <Grid container>
                <Grid item xs={12}>
                    <Loader />
                </Grid>
            </Grid>
        )
    }
    else if(error){
        return(
            <Alert mb={4} severity="error">
                An error happened while saving your answer, please try again later
            </Alert>
        )
    }
    else{
        const filteredInvestigations = investigations.filter(inv => { 
        
            // if(props.filter === "pending"){
            //     return inv.shareStatus === 0
            // }
            // if(props.filter === "ongoing"){
            //     return inv.status === 3
            // }
            //Filtros de researcher
            if(props.filter === "draft"){
                return inv.status === 0
            }
            if(props.filter === "live"){
                return inv.status === 1
            }
            if(props.filter === "pending"){
                return inv.shareStatus === 0
            }
            else return true
        });
    
        if(filteredInvestigations.length === 0){
            return (       
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" color="textPrimary">
                            <Translate id={`investigation.show.all.researcher.no_investigations`} />
                        </Typography>
                    </Grid>
                    {(props.filter !== "pending") && 
                    [
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" color="textPrimary">
                                <Translate id="investigation.show.all.researcher.add_first_investigation" />
                                <Link to="/investigation/create" className="btn-floating btn-large waves-effect waves-light red">
                                    <ButtonAdd type="button" />
                                </Link>
                            </Typography>
                        </Grid>
                    ]
                    }
                </Grid>         
            );
        }
        else{
            return (
                <Grid container>
                    {needsInvitationLink && (
                        <Grid item xs={12}>
                            <Alert severity="info" onClose={() => setNeedsInvitationLink(false)}>
                                <Translate id="invitation.accept.use_link" />
                            </Alert>
                        </Grid>
                    )}
                    {
                    filteredInvestigations.map((inves, index) => {
                        return(
                            <Grid item xs={12}>
                                <CardInvestigation title={inves.name} key={inves.uuid}
                                    index={index}
                                    uuid={inves.uuid}
                                    description={inves.description}
                                    status={inves.status}
                                    answerRequest={inves.shareStatus === 0 ? answerRequest : null}
                                    shareStatus={inves.shareStatus}
                                    hostResearcher={inves.hostResearcher}
                                    permissions={inves.permissions}
                                    assignedRole={inves.assignedRole}
                                    textUrl={<Translate id="investigation.show.view_investigation" />}
                                    />
                            </Grid>
                        );
                    })
                }
                </Grid>
                )
        }
    }
}
AllInvestigations.propTypes = {
    initialData: PropTypes.object,
    typeUser: PropTypes.string,
    filter: PropTypes.number
}; 

export default withLocalize(AllInvestigations);
